import {useRef} from 'react';
import {getLocale} from 'epic-common/src/locale';

import useLocalization from '../../../../../hooks/useLocalization';

const CODES = {
    one: 'epic.affiliate.common.ordinals.one',
    two: 'epic.affiliate.common.ordinals.two',
    few: 'epic.affiliate.common.ordinals.few',
    other: 'epic.affiliate.common.ordinals.other'
};

export type UseOrdinalNumberFormatter = (value: number | string) => string;

const useOrdinalNumberFormatter = (): UseOrdinalNumberFormatter => {
    const getMessage = useLocalization();

    const pluralRules = useRef(
        new Intl.PluralRules(getLocale(), {
            type: 'ordinal'
        })
    );

    return value => getMessage(CODES[pluralRules.current.select(Number(value))], [value]);
};

export default useOrdinalNumberFormatter;
